import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-groups',
  templateUrl: './button-groups.component.html',
})
export class ButtonGroupsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
